module.exports = __webpack_public_path__ + "img/hearts.4aba0d4d.svg";